import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-uitemplate',
  templateUrl: './block-uitemplate.component.html',
  styleUrls: ['./block-uitemplate.component.scss']
})
export class BlockUITemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
